import React, {Component} from 'react';

/** @class Dashbaord
  * A component for rendering a user dashboard,
  * which serves as a landing page and displays
  * the vexpo elments that user is allowed to edit
  */
export default class Dashboard extends Component {
  render() {
    return (
      <div className="dashboard">
        <h1>Dashboard</h1>
        <p>Role: {}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.js